<div>
  <div id="square1" class="square"></div>
  <div id="square2" class="square"></div>
  <div id="square3" class="square"></div>
  <div id="square4" class="square"></div>
  <div id="square5" class="square"></div>
  <div id="square6" class="square"></div>
  <div id="square7" class="square"></div>
  <div id="square8" class="square"></div>
  <div id="square9" class="square"></div>
</div>
